import React from 'react';
import {decodeEntities} from '@wordpress/html-entities';
import DOMPurify from "dompurify";
import {  CheckoutButton } from '.';

const { registerPaymentMethod } = window.wc.wcBlocksRegistry
const { getSetting } = window.wc.wcSettings

const settings = getSetting( 'spgw_lunchcheck_data', {} );

const { title, save_card_html, icon, description } = settings;
const label = decodeEntities( settings.title || '' );
const desc =  DOMPurify.sanitize(description);
const cleanHTML = DOMPurify.sanitize(save_card_html);

const ContentComponent = () => {
	return <div><div dangerouslySetInnerHTML={{ __html: desc }} /><CheckoutButton />
	<div dangerouslySetInnerHTML={{ __html: cleanHTML }} /></div>;
  };
const Icon = () => {
	return icon 
		? <img alt='' src={icon} style={{ float: 'right', marginRight: '20px' }} /> 
		: '';
};
const Label = () => {
	return (
		<span style={{ width: '100%' }}>
			{title}
			<Icon />
		</span>
	);
};


registerPaymentMethod( {
	name: "spgw_lunchcheck",
	label: <Label />,
	content: <ContentComponent/>,
	edit: <ContentComponent />,
	canMakePayment: (cart) => {
		if(!settings.availability) {
			return false;
		}
		if(cart.billingAddress.country == "" || (settings.allowedCountries.length == 1 && settings.allowedCountries.includes('select'))) {
			return true;
		}
		if(settings.allowedCountries.length != 0) {
			return settings.allowedCountries.includes(cart.billingAddress.country);
		}
		return true;
	},
	ariaLabel: label,
	supports: {
		features: settings.supports,
		showSavedCards: false,
		showSaveOption: false,

	}
} )

